import { UPLOAD_PROJ_USER_REQUEST, UPLOAD_PROJ_USER_SUCCESS, UPLOAD_PROJ_USER_FAILURE,
  UPLOAD_PROJ_ADMIN_REQUEST, UPLOAD_PROJ_ADMIN_SUCCESS, UPLOAD_PROJ_ADMIN_FAILURE,
  UPLOAD_FILE_USER_REQUEST, UPLOAD_FILE_USER_SUCCESS, UPLOAD_FILE_USER_FAILURE

} from '../Constants/ActionTypes';
 import { toast } from "react-toastify";
import * as API from '../API/api.js';

export const uploadProjUser = (values,token) => async dispatch => {
  try {
    dispatch({ type: UPLOAD_PROJ_USER_REQUEST });
    const data = await API.uploadProjectUser(values,token);
    if (data) {
      toast("PROJECT UPLOADED SUCCESSFULLY")
      dispatch({ type: UPLOAD_PROJ_USER_SUCCESS, payload: data });
        // navigate('/')
       
    }
  } catch (error) {
    toast('UNSUCCESSFULL SUBMISSION');
    dispatch({ type: UPLOAD_PROJ_USER_FAILURE });
  }
};

export const uploadProjAdmin = (values,token) => async dispatch => {
  try {
    dispatch({ type: UPLOAD_PROJ_ADMIN_REQUEST });
    const data = await API.uploadProjectAdmin(values,token);
    if (data) {
      toast("PROJECT UPLOADED SUCCESSFULLY")
      dispatch({ type: UPLOAD_PROJ_ADMIN_SUCCESS, payload: data });
        // navigate('/')
       
    }
  } catch (error) {
    toast('UNSUCCESSFULL SUBMISSION');
    dispatch({ type: UPLOAD_PROJ_ADMIN_FAILURE });
  }
};


export const uploadFile= values => async dispatch => {
  try {
    dispatch({ type: UPLOAD_FILE_USER_REQUEST });
    const data = await API.fileUpload(values);
    
    if (data.data.success===true) {
      toast("FILE UPLOADED SUCCESSFULLY")
      dispatch({ type: UPLOAD_FILE_USER_SUCCESS, payload: data.data.url });
        // navigate('/')
       
    }
  } catch (error) {
    toast('PLEASE UPLOAD YOUR FILE AGAIN');
    dispatch({ type: UPLOAD_FILE_USER_FAILURE });
  }
};

